(() => {
  const PRESCRIBERY_URL = 'https://service.prescribery.com/patient-signup?token=6756a6a0-076a-4a41-b48e-86d565d6070d';
  const gate = document.querySelector('[data-evaluation-gate]');
  if (!gate) return;

  const dialog = gate.querySelector('.noviq-evaluation-gate__dialog');
  const startLink = gate.querySelector('[data-evaluation-start]');
  const continueButton = gate.querySelector('[data-evaluation-continue]');
  const helper = gate.querySelector('[data-evaluation-helper]');
  const closeButtons = gate.querySelectorAll('[data-evaluation-close]');
  let pendingAction = null;
  let lastTrigger = null;

  function openGate(action, trigger) {
    pendingAction = action;
    lastTrigger = trigger || document.activeElement;
    continueButton.disabled = true;
    continueButton.classList.remove('is-ready');
    helper.textContent = 'The evaluation will open in a new window. Return here after completing it to continue to checkout.';
    gate.hidden = false;
    document.documentElement.classList.add('noviq-gate-open');
    window.requestAnimationFrame(() => {
      gate.classList.add('is-open');
      if (dialog) dialog.focus?.();
    });
  }

  function closeGate() {
    gate.classList.remove('is-open');
    document.documentElement.classList.remove('noviq-gate-open');
    window.setTimeout(() => { gate.hidden = true; }, 180);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  async function continueToCheckout() {
    if (!pendingAction || continueButton.disabled) return;
    continueButton.disabled = true;
    continueButton.textContent = 'Preparing checkout…';
    try {
      await pendingAction();
    } catch (error) {
      console.error('Noviq checkout gate:', error);
      continueButton.disabled = false;
      continueButton.textContent = 'I’ve Completed My Evaluation — Continue to Checkout';
      helper.textContent = 'We could not continue to checkout. Please try again.';
    }
  }

  startLink.href = PRESCRIBERY_URL;
  startLink.addEventListener('click', () => {
    window.setTimeout(() => {
      continueButton.disabled = false;
      continueButton.classList.add('is-ready');
      helper.textContent = 'After completing the evaluation, return to this window and select Continue to Checkout.';
    }, 350);
  });

  continueButton.addEventListener('click', continueToCheckout);
  closeButtons.forEach(button => button.addEventListener('click', closeGate));

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !gate.hidden) closeGate();
  });

  // Cart: require the evaluation gate before Shopify checkout.
  document.querySelectorAll('[data-noviq-checkout-gate][data-gate-source="cart"]').forEach(button => {
    button.addEventListener('click', () => {
      openGate(async () => {
        window.location.assign('/checkout');
      }, button);
    });
  });

  // Product page Buy Now: add currently selected variant, then continue to checkout.
  document.querySelectorAll('[data-noviq-checkout-gate][data-gate-source="product"]').forEach(button => {
    button.addEventListener('click', () => {
      const form = button.closest('form');
      if (!form) return;
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;

      openGate(async () => {
        const body = new FormData();
        body.append('id', variantInput.value);
        body.append('quantity', '1');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body
        });
        if (!response.ok) throw new Error('Unable to add selected treatment to cart.');
        window.location.assign('/checkout');
      }, button);
    });
  });
})();
